export default {
  common: {
    And: 'and',
    GotIt: 'Got it',
    GoHome: 'Go home',
    Cancel: 'Cancel',
    Submit: 'Submit',
    Detail: 'Detail',
    OhMy: 'OOOPS!',
    EmptyData: 'no data',
    Loading: '--- loading ---',
    SubmitSuccess: 'Submit Success!',
    ChooseFile: 'Choose a file',
    FileSupport: 'File type not support',
    ExceedMaxSize3M: 'Exceed max size limit(3M)',
    ErrAgain: 'Oops…Something is wrong, please try again later.',
    NoSignal: 'No signal here! We can\'t find the page that you are looking for.',
    ErrorRefresh: 'Error! Page info has change! please refresh this page to continue!'
  },
  course: {
    Lesson: 'Lesson',
    Lessons: 'Lessons',
    Replay: 'Replay',
    Live: 'Live',
    LiveTime: 'LIVE TIME',
    Syllabus: 'Syllabus',
    CourseDetails: 'Course Details',
    CourseNoStarted: 'The course has not started yet',
    JoinCourse: 'Join the course',
    JoinCourseSuccess: 'The course selection application has been successfully submitted. After approval, you can view the course content',
    WorkTypeEpParts: 'Classic example',
    WorkTypeExItems: 'homework',
    WorkTypeCmkItems: 'classroom test',
    SubclassTitle: 'Lesson title',
    QuestionSetter: 'Question setter',
    Score: 'score',
    Percent: 'percent',
    Avg: 'avg',
    NoMoreCourses: '--- no more courses ---',
    NoReadySelling: 'Sorry, this course isn’t ready for sale or has been stopped selling.',
    NoReplay: 'No replay',
    HasApply: 'Registered',
    Approved: 'Approved',
    Reject: 'Rejection',
    LiveDuring: 'Live during {start} - {end}'
  },
  question: {
    Like: 'Like',
    Interesting: 'Interesting',
    Question: 'Question',
    AnalysisSolution: 'Analysis & Solution',
    LastQuestion: 'Last question',
    NextQuestion: 'Next question',
    QuestionList: 'Question List',
    AnswerResults: 'Answer results',
    FullMarks: 'Full marks',
    YourScore: 'Your score',
    ReportProblems: 'Report problems',
    ReportProblemsTitle: 'Please let us know your feedback.。',
    Unfamiliar: 'Unfamiliar',
    NeedToExplain: 'Need to explain',
    ItTooSimple: 'It\'s too simple',
    Custom: 'Custom',
    FeedbackDesc: 'Description of feedback',
    CustomPlaceholder: 'Please enter what you want to feedback',
    ReExamination: 'Re examination',
    KeyboardShortcutsIntroduction: 'Introduction to Keyboard shortcuts',
    IntroductionOne: '1. Pressing Shift + ←/→ to navigate to last or next question',
    IntroductionTwo: '2. just click choice in each question it is saved automatically',
    EasyQuestionTips: 'This is a free response question. You don\'t have to enter the answer.',
    SingleSelection: 'Single selection',
    MultipleSelections: 'Multiple selections',
    GapFilling: 'Gap filling',
    FreeResponse: 'Free response',
    UnAnswerTips: 'There are {num} questions that have not been answered yet. Are you sure to submit the paper?'
  },
  auth: {
    Login: 'Log in',
    LoginTitle: 'Welcome to Course System!',
    SignUp: 'Sign Up',
    Password: 'Password',
    ForgotPassword: 'Forgot Password?',
    NoAccount: 'Don\'t have an account?',
    AlreadyAccount: 'Already have an account?',
    EmailOrMobile: 'Email or mobile number',
    PasswordPlaceholder: '8 - 32 characters',
    TermsOfUse: 'Terms of use',
    PrivacyPolicy: 'Privacy Policy',
    LoginTips: 'By logging into Course System, you agree to our',
    RegisterTips: 'By signing up for Course System, you agree to our',
    RegisterDesc: 'Joining Course System you will get excellent learning material for AP Physics courses. We\'ll save all of your learning progress. One more thing, that\'s all free of use!',
    AccountRequired: 'An Email/Mobile is required to log in',
    AccountFormatErr: 'Please fill the email/mobile in correct format',
    PasswordRequired: 'A password is required to log in',
    PasswordFormatErr: 'Password has to be 8 to 32 characters',
    LoginSuccess: 'login success!',
    CheckAccount: 'Oops…Something went wrong, please check your email/mobile and try again later.',
    Inaccuracy: 'Your account or password is incorrect.',
    NoSignUp: 'This email/mobile hasn\'t sign up yet.',
    ResetPasswordMax: 'You can reset a new password. Two times per day maximum.',
    VerificationCode: 'Verification code',
    VerificationCodePlaceholder: 'Numbers with 6 digits',
    CreatePassword: 'Create a password',
    CreatePasswordPlaceholder: '8 - 32 characters, please mind to use uppercase and lowercase.',
    GetVerificationCode: 'get verification code',
    ResetPassword: 'Reset password',
    VerificationCodeRequired: 'Please enter the verification code',
    VerificationCodeFormatErr: 'Incorrect verification code',
    CreatePasswordRequired: 'Please create a password',
    CreatePasswordFormatErr: 'The password should be 8 to 32 characters. For safety, it\'s better to set a password which is never used before',
    HasSendVerificationCode: 'The verification code has been sent to your email/mobile. Please check your inbox to find the code.',
    AccountHasSignUp: 'There\'s already an account with this email/mobile. If it\'s yours, you can log in with it.',
    Err3SecondsAgainLater: 'Oops…Something is wrong, page will refresh in 3s, please try again later.',
    SendTwice: 'can\'t send email/mobile twice in 60 seconds',
    NoResetPasswordTime: 'You have used up all the chance to reset your password, please try again tomorrow.',
    NoSignUpCheckAccount: 'This email/mobile hasn\'t sign up yet. Please make sure the email/mobile account you entered is correct.',
    Max5timeCode: 'Each email/mobile account has 5 opportunities to get verification code per day and you had used up. Please sign up with verification code in the latest message or try again tomorrow.',
    LikeRobot: 'Sorry, you act like a robot so that failed to pass the test. You can try again later.',
    CheckInputValue: 'Oops…Something is wrong, please make sure it\'s correct and try again later.',
    CreateAccount: 'Create an account',
    Nickname: 'Nickname',
    NicknamePlaceholder: 'Create a nickname no longer than 32 characters',
    NicknameRequired: 'A nickname is required ',
    NicknameErr: 'The nickname should be no longer than 32 characters.',
    VerificationCodeHasExpired: 'The verification code has expired, please retry to get a new one.',
    VerificationCodeError: 'The verification code is incorrect, please check the code in the mail we sent you a few seconds ago',
    RetryAfter: 'Retry after {seconds} s'
  },
  nav: {
    Account: 'Account',
    Admin: 'Admin',
    MyCourses: 'My Courses',
    Logout: 'Log out',
    CourseCenter: 'COURSE CENTER',
    Feedback: 'Feedback',
    BackToTop: 'Back to top',
    FeedbackSuccess: 'We\'ve received your feedback, Thank you!',
    FeedbackTitle: 'We are looking forward to your feedback about our website!',
    FeedbackPlaceholder: 'Please tell us anything you want to say. It\'s really helpful to us',
    Homework: 'Homework',
    CourseDetail: 'Course Details'
  },
  user: {
    Proton: 'PROTON',
    Neutron: 'NEUTRON',
    IGetIt: 'I get it!',
    Signature: 'Attitude captions',
    EditSignature: 'Edit your personality declaration',
    EditSignaturePlaceholder: 'This is your show time! Words are, of course, the most powerful drug used by mankind.',
    EditSignatureTips: 'Once you enter the Top 10 learner list, your personalized signature along with your profile photo and nickname will be displayed on other users\' question bank page. The personalized signature should be less than 200 characters.',
    ProtonNeutronTips: 'What are PROTON and neutron?',
    ProtonNeutronIntroduction: 'Introduction to PROTON and NEUTRON',
    Username: 'Chinese name',
    UsernamePlaceholder: 'enter your chinese name',
    Nickname: 'English name',
    NicknamePlaceholder: 'enter your english name',
    School: 'School',
    SchoolPlaceholder: 'enter your school',
    Grade: 'Grade',
    GradePlaceholder: 'choose your grade',
    EditNickname: 'Edit your personality declaration',
    EditNicknamePlaceholder: 'e.g. Albert Einstein',
    AvatarPopper: 'Change Profile Picture',
    EditAvatarTitle: 'Edit your personality declaration'
  }
}
